/**
 * NSW Year 11 Standard Mathematics curriculum mapping
 */

// Export full curriculum mapping - this can be extended for other textbooks and states
export const CURRICULUM_MAP = {
  "NSW": {
    "nelson": {
      "11_advanced": [
        {
          "id": "year_11_advanced_nelson_1_1",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.01 Index laws",
          "start_page": 4,
          "end_page": 6,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_2",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.02 Zero and negative indices",
          "start_page": 7,
          "end_page": 8,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_3",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.03 Fractional indices",
          "start_page": 9,
          "end_page": 13,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_4",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.04 Simplifying algebraic expressions",
          "start_page": 14,
          "end_page": 15,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_5",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.05 Expansion",
          "start_page": 16,
          "end_page": 16,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_6",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.06 Binomial products",
          "start_page": 17,
          "end_page": 17,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_7",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.07 Special products",
          "start_page": 18,
          "end_page": 18,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_8",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.08 Factorisation",
          "start_page": 19,
          "end_page": 19,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_9",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.09 Factorisation by grouping in pairs",
          "start_page": 20,
          "end_page": 20,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_10",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.10 Factorising trinomials",
          "start_page": 21,
          "end_page": 22,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_11",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.11 Further trinomials",
          "start_page": 23,
          "end_page": 23,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_12",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.12 Perfect squares",
          "start_page": 24,
          "end_page": 24,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_13",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.13 Difference of two squares",
          "start_page": 25,
          "end_page": 25,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_14",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.14 Mixed factorisation",
          "start_page": 26,
          "end_page": 26,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_15",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.15 Simplifying algebraic fractions",
          "start_page": 27,
          "end_page": 27,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_16",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.16 Operations with algebraic fractions",
          "start_page": 28,
          "end_page": 29,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_17",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.17 Substitution",
          "start_page": 30,
          "end_page": 31,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_18",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.18 Simplifying surds",
          "start_page": 32,
          "end_page": 32,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_19",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.19 Operations with surds",
          "start_page": 33,
          "end_page": 36,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_20",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "1.20 Rationalising the denominator",
          "start_page": 37,
          "end_page": 40,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_1_test",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "Test yourself 1",
          "start_page": 41,
          "end_page": 44,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_1_challenge",
          "name": "ALGEBRAIC TECHNIQUES",
          "chapter": "1",
          "section": "Challenge exercise 1",
          "start_page": 45,
          "end_page": 45,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_2_1",
          "name": "EQUATIONS AND INEQUALITIES",
          "chapter": "2",
          "section": "2.01 Equations",
          "start_page": 48,
          "end_page": 50,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_2_2",
          "name": "EQUATIONS AND INEQUALITIES",
          "chapter": "2",
          "section": "2.02 Inequalities",
          "start_page": 51,
          "end_page": 52,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_2_3",
          "name": "EQUATIONS AND INEQUALITIES",
          "chapter": "2",
          "section": "2.03 Absolute value",
          "start_page": 53,
          "end_page": 55,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_2_4",
          "name": "EQUATIONS AND INEQUALITIES",
          "chapter": "2",
          "section": "2.04 Equations involving absolute values",
          "start_page": 56,
          "end_page": 57,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_2_5",
          "name": "EQUATIONS AND INEQUALITIES",
          "chapter": "2",
          "section": "2.05 Exponential equations",
          "start_page": 58,
          "end_page": 60,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_2_6",
          "name": "EQUATIONS AND INEQUALITIES",
          "chapter": "2",
          "section": "2.06 Solving quadratic equations by factorisation",
          "start_page": 61,
          "end_page": 61,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_2_7",
          "name": "EQUATIONS AND INEQUALITIES",
          "chapter": "2",
          "section": "2.07 Solving quadratic equations by completing the square",
          "start_page": 62,
          "end_page": 63,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_2_8",
          "name": "EQUATIONS AND INEQUALITIES",
          "chapter": "2",
          "section": "2.08 Solving quadratic equations by quadratic formula",
          "start_page": 64,
          "end_page": 65,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_2_9",
          "name": "EQUATIONS AND INEQUALITIES",
          "chapter": "2",
          "section": "2.09 Formulas and equations",
          "start_page": 66,
          "end_page": 68,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_2_10",
          "name": "EQUATIONS AND INEQUALITIES",
          "chapter": "2",
          "section": "2.10 Linear simultaneous equations",
          "start_page": 69,
          "end_page": 69,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_2_11",
          "name": "EQUATIONS AND INEQUALITIES",
          "chapter": "2",
          "section": "2.11 Non-linear simultaneous equations",
          "start_page": 70,
          "end_page": 71,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_2_12",
          "name": "EQUATIONS AND INEQUALITIES",
          "chapter": "2",
          "section": "2.12 Simultaneous equations with three unknown variables",
          "start_page": 72,
          "end_page": 73,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_2_test",
          "name": "EQUATIONS AND INEQUALITIES",
          "chapter": "2",
          "section": "Test yourself 2",
          "start_page": 74,
          "end_page": 75,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_2_challenge",
          "name": "EQUATIONS AND INEQUALITIES",
          "chapter": "2",
          "section": "Challenge exercise 2",
          "start_page": 76,
          "end_page": 76,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_practice_set_1",
          "name": "PRACTICE SET 1",
          "chapter": "",
          "section": "PRACTICE SET 1",
          "start_page": 77,
          "end_page": 81,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_3_1",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "3.01 Functions",
          "start_page": 85,
          "end_page": 91,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_3_2",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "3.02 Function notation",
          "start_page": 92,
          "end_page": 95,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_3_3",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "3.03 Properties of functions",
          "start_page": 96,
          "end_page": 102,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_3_4",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "3.04 Linear functions",
          "start_page": 103,
          "end_page": 106,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_3_5",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "3.05 The gradient of a straight line",
          "start_page": 107,
          "end_page": 112,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_3_6",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "3.06 Finding a linear equation",
          "start_page": 113,
          "end_page": 116,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_3_7",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "3.07 Parallel and perpendicular lines",
          "start_page": 117,
          "end_page": 120,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_3_8",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "3.08 Quadratic functions",
          "start_page": 121,
          "end_page": 125,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_3_9",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "3.09 Axis of symmetry",
          "start_page": 126,
          "end_page": 129,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_3_10",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "3.10 The discriminant",
          "start_page": 130,
          "end_page": 134,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_3_11",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "3.11 Finding a quadratic equation",
          "start_page": 135,
          "end_page": 138,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_3_12",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "3.12 Cubic functions",
          "start_page": 139,
          "end_page": 146,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_3_13",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "3.13 Polynomial functions",
          "start_page": 147,
          "end_page": 151,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_3_14",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "3.14 Intersection of graphs",
          "start_page": 152,
          "end_page": 157,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_3_test",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "Test yourself 3",
          "start_page": 158,
          "end_page": 161,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_3_challenge",
          "name": "FUNCTIONS",
          "chapter": "3",
          "section": "Challenge exercise 3",
          "start_page": 162,
          "end_page": 163,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_4_1",
          "name": "TRIGONOMETRY",
          "chapter": "4",
          "section": "4.01 Trigonometric ratios",
          "start_page": 168,
          "end_page": 173,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_4_2",
          "name": "TRIGONOMETRY",
          "chapter": "4",
          "section": "4.02 Finding a side of a right-angled triangle",
          "start_page": 174,
          "end_page": 177,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_4_3",
          "name": "TRIGONOMETRY",
          "chapter": "4",
          "section": "4.03 Finding an angle in a right-angled triangle",
          "start_page": 178,
          "end_page": 181,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_4_4",
          "name": "TRIGONOMETRY",
          "chapter": "4",
          "section": "4.04 Applications of trigonometry",
          "start_page": 182,
          "end_page": 189,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_4_5",
          "name": "TRIGONOMETRY",
          "chapter": "4",
          "section": "4.05 The sine rule",
          "start_page": 190,
          "end_page": 197,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_4_6",
          "name": "TRIGONOMETRY",
          "chapter": "4",
          "section": "4.06 The cosine rule",
          "start_page": 198,
          "end_page": 201,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_4_7",
          "name": "TRIGONOMETRY",
          "chapter": "4",
          "section": "4.07 Area of a triangle",
          "start_page": 202,
          "end_page": 204,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_4_8",
          "name": "TRIGONOMETRY",
          "chapter": "4",
          "section": "4.08 Mixed problems",
          "start_page": 205,
          "end_page": 210,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_4_9",
          "name": "TRIGONOMETRY",
          "chapter": "4",
          "section": "4.09 Radians",
          "start_page": 211,
          "end_page": 215,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_4_10",
          "name": "TRIGONOMETRY",
          "chapter": "4",
          "section": "4.10 Length of an arc",
          "start_page": 216,
          "end_page": 218,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_4_11",
          "name": "TRIGONOMETRY",
          "chapter": "4",
          "section": "4.11 Area of a sector",
          "start_page": 219,
          "end_page": 221,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_4_test",
          "name": "TRIGONOMETRY",
          "chapter": "4",
          "section": "Test yourself 4",
          "start_page": 222,
          "end_page": 224,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_4_challenge",
          "name": "TRIGONOMETRY",
          "chapter": "4",
          "section": "Challenge exercise 4",
          "start_page": 225,
          "end_page": 226,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_practice_set_2",
          "name": "PRACTICE SET 2",
          "chapter": "",
          "section": "PRACTICE SET 2",
          "start_page": 227,
          "end_page": 233,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_5_1",
          "name": "FURTHER FUNCTIONS",
          "chapter": "5",
          "section": "5.01 The hyperbola",
          "start_page": 236,
          "end_page": 242,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_5_2",
          "name": "FURTHER FUNCTIONS",
          "chapter": "5",
          "section": "5.02 Absolute value functions",
          "start_page": 243,
          "end_page": 247,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_5_3",
          "name": "FURTHER FUNCTIONS",
          "chapter": "5",
          "section": "5.03 Circles and semicircles",
          "start_page": 248,
          "end_page": 252,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_5_4",
          "name": "FURTHER FUNCTIONS",
          "chapter": "5",
          "section": "5.04 Reflections of functions",
          "start_page": 253,
          "end_page": 258,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_5_5",
          "name": "FURTHER FUNCTIONS",
          "chapter": "5",
          "section": "5.05 Combined and composite functions",
          "start_page": 259,
          "end_page": 263,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_5_test",
          "name": "FURTHER FUNCTIONS",
          "chapter": "5",
          "section": "Test yourself 5",
          "start_page": 264,
          "end_page": 266,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_5_challenge",
          "name": "FURTHER FUNCTIONS",
          "chapter": "5",
          "section": "Challenge exercise 5",
          "start_page": 267,
          "end_page": 267,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_6_1",
          "name": "INTRODUCTION TO CALCULUS",
          "chapter": "6",
          "section": "6.01 Gradient of a curve",
          "start_page": 271,
          "end_page": 278,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_6_2",
          "name": "INTRODUCTION TO CALCULUS",
          "chapter": "6",
          "section": "6.02 Differentiability",
          "start_page": 279,
          "end_page": 281,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_6_3",
          "name": "INTRODUCTION TO CALCULUS",
          "chapter": "6",
          "section": "6.03 Differentiation from first principles",
          "start_page": 282,
          "end_page": 291,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_6_4",
          "name": "INTRODUCTION TO CALCULUS",
          "chapter": "6",
          "section": "6.04 Short methods of differentiation",
          "start_page": 292,
          "end_page": 296,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_6_5",
          "name": "INTRODUCTION TO CALCULUS",
          "chapter": "6",
          "section": "6.05 Derivatives and indices",
          "start_page": 297,
          "end_page": 298,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_6_6",
          "name": "INTRODUCTION TO CALCULUS",
          "chapter": "6",
          "section": "6.06 Tangents and normals",
          "start_page": 299,
          "end_page": 303,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_6_7",
          "name": "INTRODUCTION TO CALCULUS",
          "chapter": "6",
          "section": "6.07 Chain rule",
          "start_page": 304,
          "end_page": 305,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_6_8",
          "name": "INTRODUCTION TO CALCULUS",
          "chapter": "6",
          "section": "6.08 Product rule",
          "start_page": 306,
          "end_page": 308,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_6_9",
          "name": "INTRODUCTION TO CALCULUS",
          "chapter": "6",
          "section": "6.09 Quotient rule",
          "start_page": 309,
          "end_page": 310,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_6_10",
          "name": "INTRODUCTION TO CALCULUS",
          "chapter": "6",
          "section": "6.10 Rates of change",
          "start_page": 311,
          "end_page": 316,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_6_test",
          "name": "INTRODUCTION TO CALCULUS",
          "chapter": "6",
          "section": "Test yourself 6",
          "start_page": 317,
          "end_page": 319,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_6_challenge",
          "name": "INTRODUCTION TO CALCULUS",
          "chapter": "6",
          "section": "Challenge exercise 6",
          "start_page": 320,
          "end_page": 321,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_7_1",
          "name": "PROBABILITY",
          "chapter": "7",
          "section": "7.01 Set notation and Venn diagrams",
          "start_page": 324,
          "end_page": 327,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_7_2",
          "name": "PROBABILITY",
          "chapter": "7",
          "section": "7.02 Relative frequency",
          "start_page": 328,
          "end_page": 331,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_7_3",
          "name": "PROBABILITY",
          "chapter": "7",
          "section": "7.03 Theoretical probability",
          "start_page": 332,
          "end_page": 336,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_7_4",
          "name": "PROBABILITY",
          "chapter": "7",
          "section": "7.04 Addition rule of probability",
          "start_page": 337,
          "end_page": 339,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_7_5",
          "name": "PROBABILITY",
          "chapter": "7",
          "section": "7.05 Product rule of probability",
          "start_page": 340,
          "end_page": 345,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_7_6",
          "name": "PROBABILITY",
          "chapter": "7",
          "section": "7.06 Probability trees",
          "start_page": 346,
          "end_page": 350,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_7_7",
          "name": "PROBABILITY",
          "chapter": "7",
          "section": "7.07 Conditional probability",
          "start_page": 351,
          "end_page": 359,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_7_test",
          "name": "PROBABILITY",
          "chapter": "7",
          "section": "Test yourself 7",
          "start_page": 360,
          "end_page": 362,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_7_challenge",
          "name": "PROBABILITY",
          "chapter": "7",
          "section": "Challenge exercise 7",
          "start_page": 363,
          "end_page": 363,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_practice_set_3",
          "name": "PRACTICE SET 3",
          "chapter": "",
          "section": "PRACTICE SET 3",
          "start_page": 364,
          "end_page": 369,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_8_1",
          "name": "EXPONENTIAL AND LOGARITHMIC FUNCTIONS",
          "chapter": "8",
          "section": "8.01 Exponential functions",
          "start_page": 372,
          "end_page": 376,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_8_2",
          "name": "EXPONENTIAL AND LOGARITHMIC FUNCTIONS",
          "chapter": "8",
          "section": "8.02 Euler's number, e",
          "start_page": 377,
          "end_page": 380,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_8_3",
          "name": "EXPONENTIAL AND LOGARITHMIC FUNCTIONS",
          "chapter": "8",
          "section": "8.03 Differentiation of exponential functions",
          "start_page": 381,
          "end_page": 384,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_8_4",
          "name": "EXPONENTIAL AND LOGARITHMIC FUNCTIONS",
          "chapter": "8",
          "section": "8.04 Logarithms",
          "start_page": 385,
          "end_page": 391,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_8_5",
          "name": "EXPONENTIAL AND LOGARITHMIC FUNCTIONS",
          "chapter": "8",
          "section": "8.05 Logarithm laws",
          "start_page": 392,
          "end_page": 396,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_8_6",
          "name": "EXPONENTIAL AND LOGARITHMIC FUNCTIONS",
          "chapter": "8",
          "section": "8.06 Logarithmic functions",
          "start_page": 397,
          "end_page": 402,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_8_7",
          "name": "EXPONENTIAL AND LOGARITHMIC FUNCTIONS",
          "chapter": "8",
          "section": "8.07 Exponential equations",
          "start_page": 403,
          "end_page": 405,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_8_test",
          "name": "EXPONENTIAL AND LOGARITHMIC FUNCTIONS",
          "chapter": "8",
          "section": "Test yourself 8",
          "start_page": 406,
          "end_page": 408,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_8_challenge",
          "name": "EXPONENTIAL AND LOGARITHMIC FUNCTIONS",
          "chapter": "8",
          "section": "Challenge exercise 8",
          "start_page": 409,
          "end_page": 409,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_9_1",
          "name": "TRIGONOMETRIC FUNCTIONS",
          "chapter": "9",
          "section": "9.01 Angles of any magnitude",
          "start_page": 412,
          "end_page": 418,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_9_2",
          "name": "TRIGONOMETRIC FUNCTIONS",
          "chapter": "9",
          "section": "9.02 Trigonometric identities",
          "start_page": 419,
          "end_page": 424,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_9_3",
          "name": "TRIGONOMETRIC FUNCTIONS",
          "chapter": "9",
          "section": "9.03 Radians",
          "start_page": 425,
          "end_page": 428,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_9_4",
          "name": "TRIGONOMETRIC FUNCTIONS",
          "chapter": "9",
          "section": "9.04 Trigonometric functions",
          "start_page": 429,
          "end_page": 441,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_9_5",
          "name": "TRIGONOMETRIC FUNCTIONS",
          "chapter": "9",
          "section": "9.05 Trigonometric equations",
          "start_page": 442,
          "end_page": 445,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_9_6",
          "name": "TRIGONOMETRIC FUNCTIONS",
          "chapter": "9",
          "section": "9.06 Applications of trigonometric functions",
          "start_page": 446,
          "end_page": 448,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_9_test",
          "name": "TRIGONOMETRIC FUNCTIONS",
          "chapter": "9",
          "section": "Test yourself 9",
          "start_page": 449,
          "end_page": 450,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_9_challenge",
          "name": "TRIGONOMETRIC FUNCTIONS",
          "chapter": "9",
          "section": "Challenge exercise 9",
          "start_page": 451,
          "end_page": 451,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_10_1",
          "name": "DISCRETE PROBABILITY DISTRIBUTIONS",
          "chapter": "10",
          "section": "10.01 Random variables",
          "start_page": 454,
          "end_page": 455,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_10_2",
          "name": "DISCRETE PROBABILITY DISTRIBUTIONS",
          "chapter": "10",
          "section": "10.02 Discrete probability distributions",
          "start_page": 456,
          "end_page": 466,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_10_3",
          "name": "DISCRETE PROBABILITY DISTRIBUTIONS",
          "chapter": "10",
          "section": "10.03 Mean or expected value",
          "start_page": 467,
          "end_page": 474,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_10_4",
          "name": "DISCRETE PROBABILITY DISTRIBUTIONS",
          "chapter": "10",
          "section": "10.04 Variance and standard deviation",
          "start_page": 475,
          "end_page": 480,
          "type": "content"
        },
        {
          "id": "year_11_advanced_nelson_10_test",
          "name": "DISCRETE PROBABILITY DISTRIBUTIONS",
          "chapter": "10",
          "section": "Test yourself 10",
          "start_page": 481,
          "end_page": 484,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_10_challenge",
          "name": "DISCRETE PROBABILITY DISTRIBUTIONS",
          "chapter": "10",
          "section": "Challenge exercise 10",
          "start_page": 485,
          "end_page": 486,
          "type": "practice_questions"
        },
        {
          "id": "year_11_advanced_nelson_practice_set_4",
          "name": "PRACTICE SET 4",
          "chapter": "",
          "section": "PRACTICE SET 4",
          "start_page": 487,
          "end_page": 491,
          "type": "practice_questions"
        }
      ]
    },
    "cambridge": {
      "11_standard": [
        {
          "id": "year_11_standard_cambridge_1_1",
          "name": "Preliminary Preparation",
          "chapter": "1",
          "section": "1A Simplifying Algebraic Expressions",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_1_2",
          "name": "Preliminary Preparation",
          "chapter": "1",
          "section": "1B Index Laws",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_1_3",
          "name": "Preliminary Preparation",
          "chapter": "1",
          "section": "1C Expanding Algebraic Expressions",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_1_4",
          "name": "Preliminary Preparation",
          "chapter": "1",
          "section": "1D Pythagoras’ Theorem",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_1_5",
          "name": "Preliminary Preparation",
          "chapter": "1",
          "section": "1E Perimeter",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_1_6",
          "name": "Preliminary Preparation",
          "chapter": "1",
          "section": "1F Area",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_1_7",
          "name": "Preliminary Preparation",
          "chapter": "1",
          "section": "1G Simple Interest",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_1_8",
          "name": "Preliminary Preparation",
          "chapter": "1",
          "section": "1H Compound Interest",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_1_9",
          "name": "Preliminary Preparation",
          "chapter": "1",
          "section": "1I Frequency Tables",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_1_10",
          "name": "Preliminary Preparation",
          "chapter": "1",
          "section": "1J Mean, Median and Mode",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_2_1",
          "name": "Earning and Managing Money",
          "chapter": "2",
          "section": "2A Salary and Wages",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_2_2",
          "name": "Earning and Managing Money",
          "chapter": "2",
          "section": "2B Bonuses and Annual Leave Loading",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_2_3",
          "name": "Earning and Managing Money",
          "chapter": "2",
          "section": "2C Overtime and Special Allowances",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_2_4",
          "name": "Earning and Managing Money",
          "chapter": "2",
          "section": "2D Commission",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_2_5",
          "name": "Earning and Managing Money",
          "chapter": "2",
          "section": "2E Piecework and Royalties",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_2_6",
          "name": "Earning and Managing Money",
          "chapter": "2",
          "section": "2F Tax Deductions",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_2_7",
          "name": "Earning and Managing Money",
          "chapter": "2",
          "section": "2G Taxable Income",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_2_8",
          "name": "Earning and Managing Money",
          "chapter": "2",
          "section": "2H Gross Pay and Net Pay",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_2_9",
          "name": "Earning and Managing Money",
          "chapter": "2",
          "section": "2I Calculating Tax",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_3_1",
          "name": "Equations and Formulae",
          "chapter": "3",
          "section": "3A Substitution",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_3_2",
          "name": "Equations and Formulae",
          "chapter": "3",
          "section": "3B Distance, Speed and Time",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_3_3",
          "name": "Equations and Formulae",
          "chapter": "3",
          "section": "3C Linear Equations",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_3_4",
          "name": "Equations and Formulae",
          "chapter": "3",
          "section": "3D Solving Formulas",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_3_5",
          "name": "Equations and Formulae",
          "chapter": "3",
          "section": "3E Changing the Subject of a Formula",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_3_6",
          "name": "Equations and Formulae",
          "chapter": "3",
          "section": "3F Blood Alcohol Content",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_3_7",
          "name": "Equations and Formulae",
          "chapter": "3",
          "section": "3G Medication",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_4_1",
          "name": "Measurement and Energy",
          "chapter": "4",
          "section": "4A Units of Measurement",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_4_2",
          "name": "Measurement and Energy",
          "chapter": "4",
          "section": "4B Measurement Errors",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_4_3",
          "name": "Measurement and Energy",
          "chapter": "4",
          "section": "4C Significant Figures and Scientific Notation",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_4_4",
          "name": "Measurement and Energy",
          "chapter": "4",
          "section": "4D Food and Nutrition",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_4_5",
          "name": "Measurement and Energy",
          "chapter": "4",
          "section": "4E Energy Consumption",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_5_1",
          "name": "Relative frequency and probability",
          "chapter": "5",
          "section": "5A Using the language of probability",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_5_2",
          "name": "Relative frequency and probability",
          "chapter": "5",
          "section": "5B Definition of probability",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_5_3",
          "name": "Relative frequency and probability",
          "chapter": "5",
          "section": "5C Tables and tree diagrams",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_5_4",
          "name": "Relative frequency and probability",
          "chapter": "5",
          "section": "5D Range of probability",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_5_5",
          "name": "Relative frequency and probability",
          "chapter": "5",
          "section": "5E Complementary events",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_5_6",
          "name": "Relative frequency and probability",
          "chapter": "5",
          "section": "5F Relative frequency",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_5_7",
          "name": "Relative frequency and probability",
          "chapter": "5",
          "section": "5G Expected frequency and expected value",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_6_1",
          "name": "Perimeter, area and volume",
          "chapter": "6",
          "section": "6A Area of Circles and Sectors",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_6_2",
          "name": "Perimeter, area and volume",
          "chapter": "6",
          "section": "6B Area of Composite Shapes",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_6_3",
          "name": "Perimeter, area and volume",
          "chapter": "6",
          "section": "6C Trapezoidal Rule",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_6_4",
          "name": "Perimeter, area and volume",
          "chapter": "6",
          "section": "6D Surface Area of Right Prisms",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_6_5",
          "name": "Perimeter, area and volume",
          "chapter": "6",
          "section": "6E Surface Area of Cylinders and Spheres",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_6_6",
          "name": "Perimeter, area and volume",
          "chapter": "6",
          "section": "6F Surface Area of Pyramids and Cones",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_6_7",
          "name": "Perimeter, area and volume",
          "chapter": "6",
          "section": "6G Volume of Prisms",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_6_8",
          "name": "Perimeter, area and volume",
          "chapter": "6",
          "section": "6H Volume of Cylinders and Spheres",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_6_9",
          "name": "Perimeter, area and volume",
          "chapter": "6",
          "section": "6I Volume of Pyramids and Cones",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_6_10",
          "name": "Perimeter, area and volume",
          "chapter": "6",
          "section": "6J Surface Area and Volume of Composite Solids",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_6_11",
          "name": "Perimeter, area and volume",
          "chapter": "6",
          "section": "6K Capacity",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_7_1",
          "name": "Data",
          "chapter": "7",
          "section": "7A Collecting Data",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_7_2",
          "name": "Data",
          "chapter": "7",
          "section": "7B Classifying Data",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_7_3",
          "name": "Data",
          "chapter": "7",
          "section": "7C Dot Plots and Stem‑and‑Leaf Plots",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_7_4",
          "name": "Data",
          "chapter": "7",
          "section": "7D Grouped Frequency Tables",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_7_5",
          "name": "Data",
          "chapter": "7",
          "section": "7E Cumulative Frequency",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_7_6",
          "name": "Data",
          "chapter": "7",
          "section": "7F Frequency Histogram and Polygon",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_7_7",
          "name": "Data",
          "chapter": "7",
          "section": "7G Pareto Charts",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_7_8",
          "name": "Data",
          "chapter": "7",
          "section": "7H Motor Vehicle Statistics",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_7_9",
          "name": "Data",
          "chapter": "7",
          "section": "7I Water Usage",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_8_1",
          "name": "Linear relationships",
          "chapter": "8",
          "section": "8A Graphing Linear Functions",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_8_2",
          "name": "Linear relationships",
          "chapter": "8",
          "section": "8B Gradient and Intercept",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_8_3",
          "name": "Linear relationships",
          "chapter": "8",
          "section": "8C Gradient‑Intercept Formula",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_8_4",
          "name": "Linear relationships",
          "chapter": "8",
          "section": "8D Linear Models",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_8_5",
          "name": "Linear relationships",
          "chapter": "8",
          "section": "8E Direct Variation",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_9_1",
          "name": "Interest and depreciation",
          "chapter": "9",
          "section": "9A Simple Interest Continued",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_9_2",
          "name": "Interest and depreciation",
          "chapter": "9",
          "section": "9B Simple Interest Graphs",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_9_3",
          "name": "Interest and depreciation",
          "chapter": "9",
          "section": "9C Percentage Increase and Decrease",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_9_4",
          "name": "Interest and depreciation",
          "chapter": "9",
          "section": "9D Calculating GST and VAT",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_9_5",
          "name": "Interest and depreciation",
          "chapter": "9",
          "section": "9E Straight Line Depreciation",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_10_1",
          "name": "Exploring and describing data",
          "chapter": "10",
          "section": "10A Measures of Central Tendency",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_10_2",
          "name": "Exploring and describing data",
          "chapter": "10",
          "section": "10B Measures of Spread",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_10_3",
          "name": "Exploring and describing data",
          "chapter": "10",
          "section": "10C Outliers",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_10_4",
          "name": "Exploring and describing data",
          "chapter": "10",
          "section": "10D Describing Distributions",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_10_5",
          "name": "Exploring and describing data",
          "chapter": "10",
          "section": "10E Comparing Distributions",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_10_6",
          "name": "Exploring and describing data",
          "chapter": "10",
          "section": "10F Parallel Box‑and‑Whisker Plots",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_11_1",
          "name": "Working with time",
          "chapter": "11",
          "section": "11A Units of Time",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_11_2",
          "name": "Working with time",
          "chapter": "11",
          "section": "11B Timetables",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_11_3",
          "name": "Working with time",
          "chapter": "11",
          "section": "11C Latitude and Longitude",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_11_4",
          "name": "Working with time",
          "chapter": "11",
          "section": "11D Time Zones",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_11_5",
          "name": "Working with time",
          "chapter": "11",
          "section": "11E Time Differences and Local Time",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_12_1",
          "name": "Budgeting and household expenses",
          "chapter": "12",
          "section": "12A Interpreting House‑bill Costs",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_12_2",
          "name": "Budgeting and household expenses",
          "chapter": "12",
          "section": "12B Motor Vehicle Budgeting",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_12_3",
          "name": "Budgeting and household expenses",
          "chapter": "12",
          "section": "12C Loan Repayments and Interest",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_12_4",
          "name": "Budgeting and household expenses",
          "chapter": "12",
          "section": "12D Motor Vehicle Insurance",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_12_5",
          "name": "Budgeting and household expenses",
          "chapter": "12",
          "section": "12E Stamp Duty Calculations",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_12_6",
          "name": "Budgeting and household expenses",
          "chapter": "12",
          "section": "12F Fuel Consumption and Running Costs",
          "type": "content"
        },
        {
          "id": "year_11_standard_cambridge_12_7",
          "name": "Budgeting and household expenses",
          "chapter": "12",
          "section": "12G Preparing a Personal Budget",
          "type": "content"
        }
      ]
    }
  }
};

// Add a generic textbook option that mirrors the existing supported content
CURRICULUM_MAP.NSW.general = {
  "11_standard": CURRICULUM_MAP.NSW.cambridge["11_standard"],
  "11_advanced": CURRICULUM_MAP.NSW.nelson["11_advanced"]
};
